/**
 * Copyright (c) 2024 FMR LLC.
 * All Rights Reserved.
 * Fidelity Confidential Information.
 */

// load these polyfills before any pvd components
import '@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js';
import '@webcomponents/webcomponentsjs/webcomponents-bundle.js';
// global styles
import './scss/main.scss';

import {
    PvdAlert,
    PvdButton,
    PvdContentBlock,
    PvdExpandCollapse,
    PvdFieldGroup,
    PvdIcon,
    PvdInlineAlert,
    PvdInput,
    PvdLabel,
    PvdLink,
    PvdListGroup,
    PvdMicrocopy,
    PvdModal,
    PvdPopover,
    PvdProgressIndicator,
    PvdSpinner,
    PvdTitle,
    PvdTooltip,
    injectSpriteSheet
} from '@fmr-ap109253/apex-kit';

import { ApexCurrency } from '@fmr-pr103625/apex-currency';
import App from './App.vue';
import { createApp } from 'vue';
import router from './router';

const APEX_NAMESPACE = 'apex';

injectSpriteSheet();
PvdAlert.defineCustomElement();
PvdButton.defineCustomElement();
PvdContentBlock.defineCustomElement();
PvdExpandCollapse.defineCustomElement();
PvdFieldGroup.defineCustomElement();
PvdIcon.defineCustomElement();
PvdInlineAlert.defineCustomElement();
PvdInput.defineCustomElement();
PvdLabel.defineCustomElement();
PvdLink.defineCustomElement();
PvdListGroup.defineCustomElement();
PvdMicrocopy.defineCustomElement();
PvdModal.defineCustomElement();
PvdPopover.defineCustomElement();
PvdProgressIndicator.defineCustomElement();
PvdSpinner.defineCustomElement();
PvdTitle.defineCustomElement();
PvdTooltip.defineCustomElement();
ApexCurrency.defineCustomElement(APEX_NAMESPACE);

createApp(App).use(router).mount('#app');
